import { CASES } from './constants';

const getInitialProductSort = () => {
    const saved = localStorage.getItem('productSort');
    return saved ? JSON.parse(saved) : ['id', 'ASC'];
};

const initialState = {
    products: [],
    versions: '',
    contractualParties: [],
    cmContractualParties: [],
    filterForm: {
        productId: '',
        productTitle: '',
        classFilter: '',
        loadStatus: '',
        legalStatusId: '',
        startYear: '',
        endYear: '',
        foxFinancialTitleId: '',
    },
    classOptions: [
        { label: 'BONUS', value: 'BONUS' },
        { label: 'COMPONENT', value: 'COMPONENT' },
        { label: 'EDUCATIONAL', value: 'EDUCATIONAL' },
        { label: 'FEATURE', value: 'FEATURE' },
        { label: 'FEATURETTE', value: 'FEATURETTE' },
        { label: 'HOME VIDEO', value: 'HOME VIDEO' },
        { label: 'INTERSTITIAL', value: 'INTERSTITIAL' },
        { label: 'MINI SERIES', value: 'MINI SERIES' },
        { label: 'PILOT', value: 'PILOT' },
        { label: 'SERIES', value: 'SERIES' },
        { label: 'SHORT', value: 'SHORT' },
        { label: 'SPECIAL', value: 'SPECIAL' },
        { label: 'TV MOVIE', value: 'TV MOVIE' },
    ],
    loadStatusOptions: [
        { label: 'READY', value: 'READY' },
        { label: 'COMPLETE', value: 'COMPLETE' },
        { label: 'ERROR', value: 'ERROR' },
        { label: 'SKIPPED', value: 'SKIPPED' },
        { label: 'HOLD', value: 'HOLD' },
        { label: 'IN_PROGRESS', value: 'IN_PROGRESS' },
        { label: 'REPROCESS', value: 'REPROCESS' },
    ],
    legalStatusOptions: [
        { label: 'CONFIRMED', value: 1 },
        { label: 'DRAFT', value: 2 },
        { label: 'PENDING', value: 3 },
        { label: 'PENDING WITH FEATURE CAVEAT', value: 4 },
        { label: 'PRELIMINARY', value: 5 },
        { label: 'PROCESSING', value: 7 },
    ],
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
    filterParam: '',
    productRange: [0, 19],
    productSort: getInitialProductSort(),
    defaultFilterRange: [0, 19],
    itemsPerPage: 20,
    isDetailsOpen: false,
    isCreateModalOpen: false,
    details: [],
    clearanceMemoTOC: [],
    title: [],
    isMemoModalOpen: false,
    isSectionModalOpen: false,
    isViewOnly: false,
    section: [],
    product: [],
};

/**
 * Reducer function to manage the products state in the Redux store.
 * It handles actions related to updating products, filtering products,
 * and clearing products.
 *
 * @param state
 * @param action
 * @return {Object} The new state of the products after applying the action.
 **/
export function products(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_PRODUCTS: {
            if (payload.productSort) {
                localStorage.setItem('productSort', JSON.stringify(payload.productSort));
            }
            return { ...state, ...payload };
        }
        case CASES.UPDATE_PRODUCTS_FILTER_FORM: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
        case CASES.CLEAR_PRODUCTS: {
            return {
                ...initialState,
                productSort: state.productSort
            };
        }
        default:
            return state;
    }
}
